<div class = "kengetaloverzicht">
  <app-kengetal
  *ngFor="let getal of kengetallen" [kengetal]="getal">
  </app-kengetal>
</div>
